/* 组件需要提供parent字段，指定表格的className（字符串） */
const rafThrottle = (fn) => {
    let locked = false;
    return function (...args) {
        if (locked) return;
        locked = true;
        window.requestAnimationFrame((_) => {
            fn.apply(this, args);
            locked = false;
        });
    };
};
export default {
    computed: {
        // 如果是公共组件mTable，需要通过props传入参needSticky为true才生效(为了避免影响全局),手动添加到页面文件的默认生效
        isNeedSticky() {
            return this.$options.name !== 'mTable' || this.needSticky;
        },
    },
    mounted() {
        if (!this.isNeedSticky) return;
        this.containerDom = document.getElementsByClassName('layout-main') || document.getElementsByClassName('layout'); // 新版 || 旧版
        this.clearListener();
        const timer = setTimeout(() => {
            this.initFixedHeader();
            clearTimeout(timer);
        }, 300);
        window.addEventListener('resize', this.resizeChange);
    },
    deactivated() {
        if (!this.isNeedSticky) return;
        this.clearListener();
    },
    beforeDestroy() {
        if (!this.isNeedSticky) return;
        this.clearListener();
        // 取消监听窗口大小
        window.removeEventListener('resize', this.resizeChange);
    },
    activated() {
        if (!this.isNeedSticky) return;
        this.initFixedHeader();
        this.updateFixedRight();
        window.addEventListener('resize', this.resizeChange);
        const timer = setTimeout(() => {
            const container = this.containerDom;
            if (container[0].scrollTop > 0) {
                container[0].scrollTop += 2;
            }
            clearTimeout(timer);
        }, 1000);
    },
    methods: {
        activatedReload() {
            window.addEventListener('resize', this.resizeChange);
            const timer = setTimeout(() => {
                this.clearFixedStyle();
                this.initFixedHeader();
            }, 300);
            this.timerList.push(timer);
        },
        reset() {
            this.clearFixedStyle();
        },
        // 窗口大小变化时，初始化
        resizeChange() {
            this.headerDragend();
            const timer = setTimeout(() => {
                this.initFixedHeader();
                clearTimeout(timer);
            }, 300);
        },
        async initFixedHeader() {
            if (this.parent) {
                // console.log('启动监听，页面：', this.parent)
                this.parentDom = document.getElementsByClassName(this.parent);
                if (this.parentDom && this.parentDom.length !== 0) {
                    this.tableWidth = this.parentDom[0]
                        .querySelector('.m-table-header')
                        .getBoundingClientRect().width;
                    this.setScrollXWidth();
                    this.tableDom = this.parentDom[0].getElementsByClassName('m-table-header');
                    this.scrollDom = document.querySelector('.layout-main') || document.querySelector('.layout'); // 新版 || 旧版
                    this.scrollDom.addEventListener('scroll', this.scrollEvent);
                    this.scrollEvent(); // 修复切换页面后吸顶未重置bug
                }
            }
        },
        // 清空监听事件
        clearListener() {
            if (this.scrollDom) {
                this.scrollDom.removeEventListener('scroll', this.scrollEvent);
                window.removeEventListener('resize', this.resizeChange);
                this.clearFixedStyle();
                // console.log('卸载监听,页面：', this.parent)
                this.timerList.forEach((key) => {
                    clearTimeout(key);
                });
            }
        },
        // 更新右侧固定栏
        updateFixedRight() {
            const { fixedRightHeaderDom, dom } = this.getFixedDom();
            if (dom.classList.contains('fixed')) {
                const timer = setTimeout(() => {
                    this.setFixedStyle({
                        dom: fixedRightHeaderDom,
                        left: `${this.fixedRightDom[0].getBoundingClientRect().left}px`,
                        width: getComputedStyle(this.fixedRightDom[0]).width,
                        scrollLeft: fixedRightHeaderDom.scrollWidth,
                    });
                    clearTimeout(timer);
                }, 100);
            }
        },
        async headerDragend() {
            await this.updateWidth();
            // await this.updateFixedRight(); 修复右侧吸顶不复位问题
            this.setScrollXWidth();
            // await this.updateHeaderHeight()
        },
        setScrollXWidth() {
            const timer = setTimeout(() => {
                if (!this.parentDom) this.parentDom = document.getElementsByClassName(this.parent);
                if (this.parentDom.length === 0) return;
                const dom = this.parentDom[0].querySelector('.m-table-header table');
                this.tableWidth = this.parentDom[0]
                    .querySelector('.m-table-body')
                    .getBoundingClientRect().width || this.parentDom[0]
                    .querySelector('.m-table-tip')
                    .getBoundingClientRect().width;
                this.tableDom[0].style.width = `${this.tableWidth}px`;
                this.updateHeaderHeight();
                this.headerWidth = dom.style.width;
                clearTimeout(timer);
            }, 200);
        },
        // 更新表格宽度，（拖拽改变宽度时使用）
        updateWidth() {
            if (!this.parentDom) this.parentDom = document.getElementsByClassName(this.parent);
            const bodyWrapperDom = this.parentDom[0].getElementsByClassName('m-table-body')[0];
            const { width } = getComputedStyle(bodyWrapperDom); // 表格宽度
            // 给表格设置宽度。
            const tableParent = this.tableDom;
            for (let i = 0; i < tableParent.length; i++) {
                tableParent[i].style.width = width;
            }
        },
        getFixedDom() {
            let fixedRightHeaderDom; let fixedRightBox; let fixedLeftHeaderDom; let
                fixedLeftBox;
            const dom = this.tableDom[0];
            if (this.fixedLeftDom && this.fixedLeftDom[0]) {
                const lefarr = this.fixedLeftDom[0].children;
                fixedLeftHeaderDom = lefarr[0];
                fixedLeftBox = lefarr[1];
            }
            if (this.fixedRightDom && this.fixedRightDom[0]) {
                const rightarr = this.fixedRightDom[0].children;
                fixedRightHeaderDom = rightarr[0];
                fixedRightBox = rightarr[1];
            }
            return {
                fixedRightHeaderDom, fixedRightBox, fixedLeftHeaderDom, fixedLeftBox, dom,
            };
        },
        // 更新表头高度，表头高度有可能改变
        updateHeaderHeight() {
            this.$nextTick(() => {
                this.tableDom = this.parentDom[0].getElementsByClassName('m-table-header');
                const obj = this.tableDom[0].getBoundingClientRect();
                if (obj.height !== this.tablexy.height) {
                    this.tablexy.height = obj.height;
                    const { dom } = this.getFixedDom();
                    if (dom.classList.contains('fixed')) {
                        const timer = setTimeout(() => {
                            this.parentDom[0].getElementsByClassName('m-table-fixed-body')[0].style.top = 0;
                            const container = this.containerDom;
                            if (container && container[0]) {
                                container[0].scrollTop = container[0].scrollTop + 3;
                            }
                            clearTimeout(timer);
                        }, 100);
                    }
                }
            });
        },
        // 获取表格属性
        getTableXy() {
            this.tablexy = this.tableDom[0].getBoundingClientRect();
            this.tablexy.height = this.tableDom[0].offsetHeight;
            return this.tablexy;
        },
        getDom() {
            if (!this.parentDom) {
                this.parentDom = document.getElementsByClassName(this.parent);
            }
        },
        // 滚动事件
        scrollEvent: rafThrottle(async function (e) {
            this.getDom();
            this.tableDom = this.parentDom[0].getElementsByClassName('m-table-header');
            if (this.tablexy.top === 0 || !this.tablexy.height || !this.tablexy.top) {
                await this.getTableXy();
            }
            this.fixedRightDom = this.parentDom[0].getElementsByClassName('m-table-fixed-right');
            this.fixedLeftDom = this.parentDom[0].getElementsByClassName('m-table-fixed');
            const { left } = this.tablexy;
            const {
                fixedRightHeaderDom, fixedRightBox, fixedLeftHeaderDom, fixedLeftBox, dom,
            } = this.getFixedDom();
            // 获取表格到顶部的距离
            const parentTop = this.parentDom[0].getElementsByClassName('m-table')[0].getBoundingClientRect().top; // 修复吸顶
            if (parentTop - this.fixedTop <= 0) {
                this.fixedbodyWrapper(this.fixedbodyWrapperTop);
                // 存在右侧固定表头
                if (fixedRightHeaderDom) {
                    fixedRightHeaderDom.style.position = 'fixed';
                    fixedRightHeaderDom.style.zIndex = '1000';
                    fixedRightHeaderDom.style.top = `${this.fixedTop}px`;
                    this.fixedRightDom[0].style.zIndex = '999';
                    // fixedRightBox.style.top = this.fixedTop;
                }
                // 左侧固定
                if (fixedLeftHeaderDom) {
                    this.setFixedStyle({
                        dom: fixedLeftHeaderDom,
                        left: `${left}px`,
                        width: getComputedStyle(this.fixedLeftDom[0]).width,
                        scrollLeft: 0,
                    });
                    fixedLeftBox.style.top = this.fixedTop;
                }
                dom.classList.add('fixed'); // 加一个固定标识
                this.updateWidth();
                dom.style.position = 'fixed';
                dom.style.zIndex = '900';
                dom.style.top = `${this.fixedTop}px`;
                dom.style.overflow = 'hidden';
                // dom.style.paddingTop = '10px';
                // dom.style.backgroundColor = '#fff';
            } else {
                this.fixedbodyWrapper('0px');
                this.clearFixedStyle();
            }
        }),
        // 设置固定
        setFixedStyle(data) {
            const {
                dom, scrollLeft, width, left,
            } = data;
            dom.style.zIndex = '900';
            dom.style.position = 'fixed';
            dom.style.top = `${this.fixedTop}px`;
            dom.scrollLeft = scrollLeft;
            dom.style.width = width;
            dom.style.overflow = 'hidden';
            dom.style.left = left;
        },
        // 清除header固定
        clearFixedStyle() {
            if (!this.tableDom) return;
            const { height, left } = this.tablexy;
            const {
                dom, fixedRightHeaderDom, fixedRightBox, fixedLeftHeaderDom, fixedLeftBox,
            } = this.getFixedDom();
            if (dom.classList.contains('fixed')) {
                if (fixedRightHeaderDom) {
                    // fixedRightBox.style.top = `${height}px`;
                    fixedRightHeaderDom.removeAttribute('style');
                }
                if (fixedLeftHeaderDom) {
                    fixedLeftHeaderDom.style.zIndex = '0';
                    fixedLeftHeaderDom.style.position = 'static';
                    fixedLeftHeaderDom.style.top = `${0}px`;
                    fixedLeftHeaderDom.style.left = `${left}px`;
                    // fixedLeftBox.style.top = getComputedStyle(dom).height;
                }
                dom.classList.remove('fixed');
                dom.style.position = 'static';
                dom.style.top = '0';
                dom.style.zIndex = '0';
            }
        },
        // 解决table表格 特定高度 抖动问题
        fixedbodyWrapper(topPx) {
            const bodyWrapper = this.parentDom[0].getElementsByClassName('m-table-body')[0];
            const fixedbodyWrapper = this.parentDom[0].getElementsByClassName('m-table-fixed')[0];
            const fixedbodyWrapperright = this.parentDom[0].getElementsByClassName('m-table-fixed-right')[0];
            if (bodyWrapper) {
                bodyWrapper.style.marginTop = topPx;
            }
            if (fixedbodyWrapper) {
                fixedbodyWrapper.style.marginTop = topPx;
                fixedbodyWrapper.style.height = `calc(100% - ${topPx})`;
            }
            if (fixedbodyWrapperright) {
                fixedbodyWrapperright.style.marginTop = topPx;
                fixedbodyWrapperright.style.height = `calc(100% - ${topPx})`;
            }
        },
    },
    data() {
        return {
            tablexy: {}, // 表格的左边宽度信息
            fixedRightDom: null, // 右侧
            fixedLeftDom: null, // 左侧栏固定
            scrollDom: null, // 滚动的dom
            parentDom: null, // 表格的父元素dom
            tableWidth: 0,
            fixedTop: 90, // 顶部fixed高度
            fixedbodyWrapperTop: '30px', // table row height
            timerList: [],
            tableDom: null,
            containerDom: null,
        };
    },
};
